// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__q7R2z"};